import script from "./LeaderboardSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeaderboardSection.vue?vue&type=script&setup=true&lang=ts"

import "./LeaderboardSection.vue?vue&type=style&index=0&id=ff83264c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff83264c"]])

export default __exports__